import { i18nProvider } from "@trumpf/ux.i18n";
import { datesAreOnSameDay, datesAreOnSameMonth } from "../../utils/date-utils";
var NotificationClusterNamesEnum;
(function (NotificationClusterNamesEnum) {
    NotificationClusterNamesEnum["TODAY"] = "today";
    NotificationClusterNamesEnum["YESTERDAY"] = "yesterday";
    NotificationClusterNamesEnum["WEEK"] = "week";
    NotificationClusterNamesEnum["MONTH"] = "month";
    NotificationClusterNamesEnum["OLDER"] = "older";
})(NotificationClusterNamesEnum || (NotificationClusterNamesEnum = {}));
export const getNotificationClusterName = (notification) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const notificationDate = new Date(notification.timestamp * 1000);
    if (datesAreOnSameDay(notificationDate, today)) {
        return NotificationClusterNamesEnum.TODAY;
    }
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);
    if (datesAreOnSameDay(notificationDate, yesterday)) {
        return NotificationClusterNamesEnum.YESTERDAY;
    }
    if (notificationDate.getTime() > today.getTime() - 7 * 24 * 60 * 60 * 1000) {
        return NotificationClusterNamesEnum.WEEK;
    }
    if (datesAreOnSameMonth(notificationDate, today)) {
        return NotificationClusterNamesEnum.MONTH;
    }
    return NotificationClusterNamesEnum.OLDER;
};
export const createNotificationCluster = (notifications) => {
    const cluster = {};
    notifications.forEach((item) => {
        const clusterName = getNotificationClusterName(item);
        if (!Array.isArray(cluster[clusterName])) {
            cluster[clusterName] = [item];
        }
        else {
            cluster[clusterName].push(item);
        }
    });
    return cluster;
};
export const getClusterName = (str) => {
    const { t } = i18nProvider;
    const fallback = `${str.slice(0, 1).toUpperCase()}${str.slice(1)}`;
    switch (str) {
        case NotificationClusterNamesEnum.TODAY:
            return t("notifications.date.today", fallback);
        case NotificationClusterNamesEnum.YESTERDAY:
            return t("notifications.date.yesterday", fallback);
        case NotificationClusterNamesEnum.WEEK:
            return t("notifications.date.lastWeek", fallback);
        case NotificationClusterNamesEnum.MONTH:
            return t("notifications.date.lastMonth", fallback);
        case NotificationClusterNamesEnum.OLDER:
        default:
            return t("notifications.date.older", fallback);
    }
};
//# sourceMappingURL=utils.js.map
